import { render, staticRenderFns } from "./plan-expo.vue?vue&type=template&id=07223ee2&"
import script from "./plan-expo.vue?vue&type=script&lang=js&"
export * from "./plan-expo.vue?vue&type=script&lang=js&"
import style0 from "./plan-expo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
